export default __webpack_public_path__ + "static/media/Monsters Rolodex.d451a917.jpg";